import {
  createEmptyLine,
  createItalicParagraphWithSpace,
  createParagraphWithCenter,
} from './docxFunctions'
import { createEffectsTable } from '@/components/reportPresentation/allTables/createCrEffectsTable'
import { createKeiTable } from '@/components/reportPresentation/allTables/createKeiTable'
import { createAvbTable } from '@/components/reportPresentation/allTables/createAvbTable'
import { createNumberedSectionHeading } from '@/components/reportPresentation/presentationSectionHeading'

/** 4. Дополнительная информация от заявителя (сравнительная клиническая эффективность). */
export function createApplicantAdditionalChapter(summary) {
  const blocks = [
    createEmptyLine(),
    createNumberedSectionHeading(4, 'ДОПОЛНИТЕЛЬНАЯ ИНФОРМАЦИЯ ОТ ЗАЯВИТЕЛЯ', {
      suffix: '',
    }),
    createEmptyLine(),
    createParagraphWithCenter(
      'Данные о сравнительной клинической эффективности',
      { size: 28, bold: true },
      null
    ),
  ]

  const effects = summary?.additionalInfo?.crEffects
  if (effects?.length) {
    blocks.push(createEffectsTable(effects))
  } else {
    blocks.push(createItalicParagraphWithSpace('Нет данных'))
  }

  blocks.push(createEmptyLine())
  return blocks
}

/** 5. Методологическое качество экономических исследований (КЭИ и АВБ). */
export function createMkQualityChapter(summary) {
  const blocks = [
    createEmptyLine(),
    createNumberedSectionHeading(
      5,
      'ДОПОЛНИТЕЛЬНАЯ ИНФОРМАЦИЯ О РЕЗУЛЬТАТАХ МЕТОДОЛОГИЧЕСКОГО КАЧЕСТВА ЭКОНОМИЧЕСКИХ ИССЛЕДОВАНИЙ (на основании данных, содержащихся в составе Предложения)',
      { suffix: '' }
    ),
    createEmptyLine(),
    createParagraphWithCenter(
      'Данные о клинико-экономической эффективности',
      { size: 28, bold: true },
      null
    ),
  ]

  const kei = summary?.additionalInfo?.kei
  if (kei?.length) {
    blocks.push(createKeiTable(kei))
  } else {
    blocks.push(createItalicParagraphWithSpace('Нет данных'))
  }

  blocks.push(createEmptyLine())
  blocks.push(
    createParagraphWithCenter('Данные о влиянии на бюджет', {
      size: 28,
      bold: true,
    }, null)
  )

  const avb = summary?.additionalInfo?.avb
  if (avb?.length) {
    blocks.push(createAvbTable(avb))
  } else {
    blocks.push(createItalicParagraphWithSpace('Нет данных'))
  }

  blocks.push(createEmptyLine())
  return blocks
}
